const state = {
  visible: false,
  size: 78,
  color: "#000",
  overlay: false,
  overlayColor: "rgba(0,0,0,0.3)",
  overlayBlur: "0px",
};

const actions = {
  showLoader({ commit }, options = {}) {
    commit("SHOW_LOADER", options);
  },
  hideLoader({ commit }) {
    commit("HIDE_LOADER");
  },
};

const mutations = {
  SHOW_LOADER(state, { size, color, overlay, overlayColor, overlayBlur }) {
    state.visible = true;
    if (size) state.size = size;
    if (color) state.color = color;
    state.overlay = overlay !== undefined ? overlay : false;

    if (overlayColor) state.overlayColor = overlayColor;
    if (overlayBlur) state.overlayBlur = overlayBlur;
  },
  HIDE_LOADER(state) {
    state.visible = false;
  },
};

const getters = {
  getLoaderVisible: (state) => state.visible,
  getLoaderSize: (state) => state.size,
  getLoaderColor: (state) => state.color,
  getLoaderOverlay: (state) => state.overlay,
  getLoaderOverlayColor: (state) => state.overlayColor,
  getLoaderOverlayBlur: (state) => state.overlayBlur,
};

export default {
  actions,
  state,
  mutations,
  getters,
};
